import React, { useState, useRef, useEffect } from "react";
import styles from "./Toggle.module.scss";

import Plus from '/packages/icons/plus.svg';
import Minus from '/packages/icons/minus.svg';
import Tag from '/packages/icons/tag.svg';

export default function Toggle(props) {
  const { title, tag, open, children } = props;
  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");

  const contentRef = useRef(null);
  const id = `toggle-content-${title.replace(/\s+/g, "-").toLowerCase()}`;

  const handleClick = () => {
    const isOpening = !active;
    setActive(isOpening);

    if (contentRef.current) {
      setHeight(isOpening ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  };

  useEffect(() => {
    if (open) {
      setActive(true);
      if (contentRef.current) {
        setHeight(`${contentRef.current.scrollHeight}px`);
      }
    }
  }, []);

  // Manage tabIndex for focusable children
  useEffect(() => {
    if (!contentRef.current) return;

    const focusables = contentRef.current.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    focusables.forEach((el) => {
      if (active) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  }, [active]);

  return (
    <div className={`${styles.toggle} ${props.class || ''}`}>
      <div
        className={styles.toggle__header}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
          }
        }}
        tabIndex={0}
        role="button"
        aria-expanded={active}
        aria-controls={id}
      >
        <span className={styles.title}>{title}</span>
        {tag && (
          <span className={styles.tag}>
            <Tag /> {tag}
          </span>
        )}
        <span className={styles.icon}>{active ? <Minus /> : <Plus />}</span>
      </div>

      <div
        className={styles.toggle__content}
        ref={contentRef}
        style={{ maxHeight: height, transition: "max-height 0.3s ease" }}
        id={id}
        aria-hidden={!active}
      >
        {children}
      </div>
    </div>
  );
}
